<div class="loading-wrapper">
    <img src="assets/img/loading.png" class="loading-icon" />
    <p class="title">{{ "please_wait" | translate }}</p>
</div>